module.exports = __webpack_public_path__ + "static/media/art_hp.03e6103b.png";